import moment from "moment";
import { cellClass, stickyCellClass } from "../_components/AdminTable";
import AdminRowActions, { EditLink } from "../_components/AdminRowActions";

const AdminUserItem = ({ user: { _id, name, email, date }, count, currentUser }) => (
  <tr>
    <td className={cellClass}>{count + 1}</td>
    <td className={cellClass}>
      <div className="tw:flex tw:flex-col">
        <span className="tw:!text-[15px] tw:!text-[#282828] tw:leading-none tw:mb-1">{name}</span>
        {email === currentUser?.email ? (
          <span className="tw:!text-[13px] tw:!text-[#A3780F] tw:leading-none">Current user</span>
        ) : null}
      </div>
    </td>
    <td className={cellClass}>{email}</td>
    <td className={`${cellClass} tw:whitespace-nowrap`}>{moment(date).locale("en").format("YYYY/MM/DD")}</td>
    <td className={stickyCellClass}>
      <AdminRowActions>
        <EditLink to={`/admin/useredit/edit/${_id}`} label="Edit admin user" />
      </AdminRowActions>
    </td>
  </tr>
);

export default AdminUserItem;
